import {
  SearchEmailRequest,
  SearchEmailResponse,
} from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../../axios';

export interface UserAlreadyExistsError {
  errorCode: string;
  additionalInfo: {
    loginType: 'CLUB' | 'CLOUD';
    clubCode: string;
    loginURL: string;
  };
}

/**
 * OTVC means One Time Verification Code. This is a branch off the Organic registration flow
 * where the user can just receive a code to the their email or SMS instead of filling out
 * all the normal organic registration policy details.
 */
export const checkOtvcEligibility = async (requestBody: SearchEmailRequest) => {
  const { data } = await axios.post<SearchEmailResponse>(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/otp/eligibility`,
    requestBody
  );

  return data;
};

export const useOtvcEligibilityMutation = () =>
  useMutation({
    mutationFn: (requestBody: SearchEmailRequest) =>
      checkOtvcEligibility(requestBody),
  });
